<template>
    <div class="w-full">
        <nav :class="pills ? 'flex flex-wrap' : 'bg-dark-lighter flex w-full rounded-lg'" aria-label="Tabs">
            <div
                v-for="(header, index) in Object.keys(headers)"
                :key="'header-' + index"
                :class="[
                    pills
                        ? modelValue == header
                            ? 'bg-dark-lightest text-brand-base'
                            : 'hover:bg-dark-lighter text-gray-500'
                        : '',
                    headers[header]?.disable && 'disabled',
                    pills && 'mx-1 cursor-pointer rounded-md px-3 py-2 text-sm font-medium',
                    !pills && 'flex h-full grow',
                ]"
                :aria-current="modelValue == header ? 'page' : undefined"
                @click.prevent.stop="emits('update:modelValue', header)"
            >
                <div v-if="pills">{{ headers[header]?.text }}</div>
                <div
                    v-else
                    :class="[
                        modelValue == header ? 'bg-dark-lightest' : 'transition duration-200 hover:scale-102',
                        index !== 0 && '-ml-1',
                        index !== Object.keys(headers).length - 1 && '-mr-1',
                        headers[header]?.disable && 'disabled',
                        'm-1 flex grow cursor-pointer items-center justify-center rounded-lg py-2',
                    ]"
                >
                    <h4>{{ headers[header]?.text }}</h4>
                </div>
            </div>
        </nav>
    </div>
</template>

<script setup>
import { watch } from 'vue'

const props = defineProps({
    /**
     * Headers of the Tabs.
     *
     * Example:
     * { sample1: 'Sample 1', sample2: 'Sample 2' }
     */
    headers: { type: Object, default: () => ({}) },

    /**
     * Classics tabs or pills tabs (like separated buttons)
     */
    pills: { type: Boolean, default: false },

    /**
     * Determines the initially selected tab by slot name.
     */
    modelValue: { type: [String, Number], default: undefined },
})

const emits = defineEmits(['update:modelValue'])

watch(
    () => props.headers,
    () => {
        if (props.headers?.[props.modelValue]?.disable) {
            let newHeaderSelected = null
            let headerCount = 0
            const headersArray = Object.entries(props.headers)

            while (newHeaderSelected === null && headerCount < headersArray.length) {
                if (!headersArray[headerCount][1].disable) {
                    newHeaderSelected = headersArray[headerCount][0]
                    emits('update:modelValue', newHeaderSelected)

                    break
                }
                headerCount++
            }
        }
    },
    { deep: true }
)
</script>
